import { useRef, useState } from 'react';
import { IPreview } from '../../dropzone.types';
import {
  PlayControl,
  StopControl,
  StyledVideo,
  VideoPreviewContainer,
  VideoPreviewControls,
} from './videoPreview.styles';

const VideoPreview = ({ preview }: { preview: IPreview }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const togglePlayback = async () => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.pause();
      video.currentTime = 0;
    } else {
      video.currentTime = 0;
      await video.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <VideoPreviewContainer
      data-testid="video-preview-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={togglePlayback}
    >
      <StyledVideo
        ref={videoRef}
        muted
        aria-label="uploaded video"
        src={preview.url}
      />
      {isHovered && (
        <VideoPreviewControls>
          <>
            {isPlaying ? (
              <StopControl>⏹</StopControl>
            ) : (
              <PlayControl>▶</PlayControl>
            )}
          </>
        </VideoPreviewControls>
      )}
    </VideoPreviewContainer>
  );
};

export default VideoPreview;
